import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {AuthService} from './auth.service';
import {StorageService} from './storage.service';

@Injectable({
    providedIn: 'root',
})
export class TabVisibilityService {
    constructor(
        private authService: AuthService,
        private storageService: StorageService,
        @Inject(PLATFORM_ID) private platformId: object,
    ) {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                this.init();
            }, 0);
        }
    }

    /**
     * Initialisiert den Event-Handler
     *
     * Führt beim ersten Öffnen des Tabs einen Storage-Refresh aus, um sicherzustellen,
     * dass die Daten aktuell sind (z.B. wenn der Benutzer eingeloggt geblieben ist und erneut einen C-World Tab öffnet)
     * Das ist nicht bemerkbar & stellt sicher, dass die Daten aktuell sind
     *
     * Führt außerdem einen refresh aus, wenn der Tab wieder sichtbar wird,
     * wenn die jeweiligen Bedingungen für einen refresh erfüllt sind.
     */
    private init(): void {
        this.runIfNeeded();

        // Wenn User zum Tab zurückkehrt
        window.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                this.runIfNeeded();
            }
        });
    }

    // Führt den storage refresh aus, wenn die Bedingungen erfüllt sind
    private runIfNeeded(): void {
        if (!this.shouldRun()) {
            return;
        }

        this.performStorageRefresh();
    }

    /**
     * Bedingungen für ein storage refresh:
     * 1. Der LOCAL storage wurde heute noch nicht aktualisiert ("lastStorageRefreshDay" ist nicht heute)
     * 2. Der SESSION storage enthält den Key "tabHasRefreshed" nicht -> das bedeutet es ist ein neuer Tab
     */
    private shouldRun(): boolean {
        const today = new Date().toISOString().slice(0, 10);
        const lastRefreshDay = this.storageService.getLastRefreshDay();
        const tabHasRefreshed = !!sessionStorage.getItem(this.storageService.SESSION_TAB_HAS_REFRESHED_KEY);

        // Prüfen, ob der Tab heute noch nicht aktualisiert wurde
        if (lastRefreshDay !== today) {
            return true;
        }

        // Prüft, ob dieser Tab bereits aktualisiert wurde
        if (!tabHasRefreshed) {
            return true;
        }

        return false;
    }

    // Storage refresh ausführen
    private performStorageRefresh(): void {
        try {
            this.authService.refresh();
        } catch (error) {
            console.error(error);
        }
    }
}
